import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Divider } from "@mui/material";

const DividerConTitulo = ({ titulo }) => {
  if (!titulo) return null;

  return (
    <Box sx={{ my: { xs: 2, sm: 4 }, textAlign: 'center' }}>
      <Typography
        variant="h4"
        component="h2"
        sx={{ fontWeight: 700, mx: 'auto', display: 'inline-block' }}
      >
        {titulo}
      </Typography>
      <Divider sx={{ width: 80, height: 2, backgroundColor: 'rgba(0,0,0,0.08)', borderRadius: 1, mx: 'auto', mt: 1 }} />
    </Box>
  );
};

DividerConTitulo.propTypes = {
  titulo: PropTypes.string,
};

export default DividerConTitulo;
